import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Construction, Home } from 'lucide-react';

/**
 * FeatureDisabledPage
 * 
 * Wird angezeigt, wenn ein temporär deaktiviertes Feature direkt
 * über die URL aufgerufen wird.
 * 
 * Nach 5 Sekunden automatische Weiterleitung zum Dashboard.
 */
const FeatureDisabledPage = ({ featureName = 'Feature' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatische Weiterleitung nach 5 Sekunden
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
            <Construction className="w-8 h-8 text-amber-600" />
          </div>
          
          <h2 className="text-xl font-semibold text-slate-900">
            {featureName} vorübergehend deaktiviert
          </h2>
          
          <p className="text-slate-600">
            Diese Funktion ist aktuell nicht verfügbar und wird zu einem späteren Zeitpunkt wieder aktiviert.
          </p>
          
          <p className="text-sm text-slate-500">
            Sie werden in 5 Sekunden automatisch weitergeleitet...
          </p>
          
          <Button 
            onClick={() => navigate('/')} 
            className="mt-4"
            data-testid="back-to-dashboard-btn"
          >
            <Home className="w-4 h-4 mr-2" />
            Zum Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default FeatureDisabledPage;
